const isDev = process.env.NODE_ENV == "development";
const useStageOverride = process.env.VUE_APP_USE_STAGE == "true";
const useProdOverride = process.env.VUE_APP_USE_PROD == "true";
const useLANOverride = process.env.VUE_APP_USE_LAN == "true";
const lanURL = process.env.VUE_APP_LOCAL_URL;
export default class ApiHelper {
    public static jsonHeaders: any = { headers: { "Content-Type": "Application/json", "Cache-Control": "no-cache" } };
    public static multipart: any = { headers: { "Content-type": "multipart/form-data" } };

    static localURL: string = "http://localhost:5033/b2c";
    static localNetworkURL: string = `${lanURL}:5550/b2c`;
    static prodURL: string = "https://b2c.pampadu.ru/b2c";
    static stageURL: string = "http://b2c.pamstage1.ru/b2c";
    public static get baseURL() {
        if (isDev) {
            if (useLANOverride) return this.localNetworkURL;
            if (useStageOverride) return this.stageURL;
            if (useProdOverride) return this.prodURL;
            return this.localURL;
        }
        const baseUrl = location.origin,
            allowedHosts = [
                'pampadu.ru',
                'pamstage1.ru',
                'pamstage2.ru',
                'pamcpa1.ru',
                'pamtest1.ru',
                'pamtest2.ru',
                'ppdu.ru',
                'pamload1.ru'
            ],
            locationHasTarget = (target: string) => location.origin.includes(target);
        if (allowedHosts.some(locationHasTarget)) return `${baseUrl}/b2c`;
        else return this.prodURL;
    }
}
